import {
  SET_ORDEN,
  ESTADO_ORDEN,
  ESTADO_ORDEN_FAIL,
  ESTADO_ORDEN_SUCCESS,
  USUARIOALTA_ORDEN,
  USUARIOALTA_ORDEN_SUCCESS, USUARIOALTA_ORDEN_FAIL
} from "../ActionTypes";
import axiosLogin from "global/helpers/axiosLogin";

export const setOrden = (orden) => (dispatch) => {
  dispatch({ type: SET_ORDEN, payload: orden });
};

export const wsGetEstadoOrden =
  (idTurno, flgTiempoDeEspera, nextStep) => (dispatch) => {
    dispatch({ type: ESTADO_ORDEN });

    axiosLogin().then((respuesta) => {
      respuesta
        .get(`his/turnos/estadoOrden/${idTurno}/${flgTiempoDeEspera}`)
        .then((resp) => {
          dispatch({ type: ESTADO_ORDEN_SUCCESS, payload: resp.data });
          if (nextStep) nextStep(resp.data, true);
        })
        .catch((err) => {
          dispatch({ type: ESTADO_ORDEN_FAIL, payload: err?.response?.data });
          if (nextStep) nextStep(err, false);
        });
    });
  };

export const wsUpdateUsuarioAltaOrden =
  (idTurno, autoCheck, nextStep) => (dispatch) => {
    dispatch({ type: USUARIOALTA_ORDEN });

    axiosLogin().then((respuesta) => {
      respuesta
        .put(`/his/turnos/actualizarUsuarioAlta/${idTurno}/${autoCheck}`)
        .then((resp) => {
          dispatch({ type: USUARIOALTA_ORDEN_SUCCESS, payload: resp.data });
          if (nextStep) nextStep(resp.data, true);
        })
        .catch((err) => {
          dispatch({ type: USUARIOALTA_ORDEN_FAIL, payload: err?.response?.data });
          if (nextStep) nextStep(err, false);
        });
    });
  };